<template>
    <div class="my-audio">
        <audio ref="audio"></audio>
        <div class="left" ref="left">
            <div class="name " ref="filename">{{ audio.filename }}</div>

            <div class="hot" @touchstart="go" @click="go">
                <div class="progress-box" ref="progressBox">
                    <span class="progress" ref="progress"></span>
                    <span
                        ref="thumb"
                        class="thumb"
                        @touchstart="handlerclick"
                        @mousedown="handlerMouse"
                    >
                        <i
                            class="show-time"
                            :class="[showMoveTime ? 'active' : '']"
                            >{{ formatterTime(moveTime) }}</i
                        >
                    </span>
                </div>
            </div>
            <div class="time">
                <span>{{ formatterTime(start) }}</span>
                <span>{{ formatterTime(end) }}</span>
            </div>
            <div class="trySee" v-if="!audio.ifFree && !audio.ifBuy">
                可试听{{ formatterTrySeeTime(audio.trySeeTime) }},<span
                    class="buy"
                    @click="buy"
                >
                    购买课程
                </span>
                收听完整内容
            </div>
        </div>
        <div class="right">
            <div
                class="playing-box btn"
                :class="[playing ? 'active' : '']"
                @click="pause"
            >
                <img src="~@/assets/audio-play3.png" alt="" />
                <img src="~@/assets/audio-play2.png" alt="" />
                <img src="~@/assets/audio-play1.png" alt="" />
            </div>
            <img
                class="btn"
                src="~@/assets/audio-pause.png"
                @click="play"
                alt=""
                :class="[!playing ? 'active' : '']"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "my-audio",
        props: ["audio", "redirect"],
        data() {
            return {
                start: 0,
                end: 0,
                w: 0,
                thumbW: 0,
                initOffsetLeft: 0,
                step: 0,
                timer: null,
                duration: 0,
                moveTime: 0,
                showMoveTime: false,
                playing: false,
                isMove: false,
            };
        },

        mounted() {
            let audioEl = this.$refs.audio;
            this.w = this.$refs.progressBox.offsetWidth;
            this.thumbW = this.$refs.thumb.offsetWidth;
            audioEl.src = this.audio.url;

            this.duration = this.end = this.audio.time;
            this.step = (this.w - this.thumbW) / this.end;

            let leftEl = this.$refs.left;
            let filenameEl = this.$refs.filename;

            let distance =
                filenameEl.offsetWidth -
                (leftEl.offsetWidth -
                    2 * parseFloat(getComputedStyle(leftEl).paddingLeft));

            audioEl.addEventListener("play", () => {
                this.playing = true;
                if (distance > 0) {
                    filenameEl.classList.add("active");
                    filenameEl.style.animationDuration =
                        (distance / 10) * 3000 + "ms";
                }
            });
        },
        methods: {
            formatterTrySeeTime(time) {
                let arr = time.split(".");
                let res = "";
                if (arr[0] > 0) {
                    res += arr[0] + "分钟";
                }
                let x_s = arr[1];
                if (arr[1] > 0) {
                    res +=
                        Math.floor(
                            (arr[1] * 60) / Math.pow(10, x_s.toString().length),
                        )
                            .toString()
                            .padStart(2, "0") + "秒";
                }
                return res;
            },
            buy() {
                if (this.redirect) {
                    location.href = this.redirect;
                } else {
                    this.$router.push({
                        path: `/pay/STUDY_EPISODE`,
                        query: { id: this.$route.params.id },
                    });
                }
            },
            clear() {
                this.playing = false;
                let audioEl = this.$refs.audio;
                this.w = this.$refs.progressBox.offsetWidth;
                this.thumbW = this.$refs.thumb.offsetWidth;
                audioEl.src = this.audio.url;

                this.duration = this.end = this.audio.time;
                this.step = (this.w - this.thumbW) / this.end;

                this.$refs.progress.style.width = 0 + "px";
                this.$refs.thumb.style.left = 0 + "px";
                this.start = 0;
                this.$refs.filename.classList.remove("active");
                clearInterval(this.timer);
            },
            play() {
                let auidoEl = this.$refs.audio;
                auidoEl.play();

                if (!auidoEl.paused) {
                    this.animation();
                }
            },
            pause() {
                let auidoEl = this.$refs.audio;
                auidoEl.pause();
                this.playing = false;
                clearInterval(this.timer);
            },
            animation() {
                if (this.timer) {
                    clearInterval(this.timer);
                }
                let left = parseFloat(getComputedStyle(this.$refs.thumb).left);
                let t = this.start;

                let res = this.trySeeEvent(this.start);
                if (res) {
                    return;
                }
                this.timer = setInterval(() => {
                    t += 1;
                    left += this.step;
                    this.start = t;

                    let res = this.trySeeEvent(this.start);
                    if (res) {
                        return;
                    }
                    if (!this.isMove) {
                        this.$refs.progress.style.width = left + "px";
                        this.$refs.thumb.style.left = left + "px";
                    }

                    if (parseInt(t) >= parseInt(this.duration)) {
                        this.playing = false;
                        left = 0;
                        this.$refs.progress.style.width = left + "px";
                        this.$refs.thumb.style.left = left + "px";
                        this.start = 0;
                        this.$refs.filename.classList.remove("active");
                        clearInterval(this.timer);
                    }
                }, 1000);
            },
            trySeeEvent(time) {
                if (!this.audio.ifFree && !this.audio.ifBuy) {
                    if (time > this.audio.trySeeTime * 60) {
                        this.$emit("trySeeEvent");
                        this.clear();
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            handlerMouse(e) {
                let target = e.target;
                let left = parseFloat(getComputedStyle(this.$refs.thumb).left);
                let startX = e.pageX;
                this.showMoveTime = true;
                this.isMove = true;
                document.body.onmousemove = (e) => {
                    let endX = e.pageX;
                    let x = endX - startX + left;
                    let time = this.calc(x);
                    this.moveTime = time;
                };
                target.onmouseup = () => {
                    this.isMove = false;
                    this.start = this.moveTime;
                    this.$refs.audio.currentTime = this.start;
                    this.showMoveTime = false;
                    document.body.onmousemove = null;
                    target.onmouseup = null;

                    this.play();
                };
            },
            handlerclick(e) {
                let target = e.target;
                let left = parseFloat(getComputedStyle(this.$refs.thumb).left);
                let startX = e.touches[0].pageX;
                this.showMoveTime = true;
                this.isMove = true;
                document.body.ontouchmove = (e) => {
                    let endX = e.touches[0].pageX;
                    let x = endX - startX + left;
                    let time = this.calc(x);
                    this.moveTime = time;
                };
                target.ontouchend = () => {
                    this.isMove = false;
                    this.start = this.moveTime;
                    this.$refs.audio.currentTime = this.start;
                    this.showMoveTime = false;
                    document.body.ontouchmove = null;
                    target.ontouchend = null;

                    this.play();
                };
            },
            go(e) {
                let endX = 0;
                if (e.touches) {
                    endX = e.touches[0].pageX;
                } else {
                    endX = e.pageX;
                }
                let x =
                    endX -
                    this.$refs.progressBox.offsetLeft -
                    this.thumbW -
                    document.documentElement.offsetLeft;
                let time = this.calc(x);
                this.$refs.audio.currentTime = this.start = time;
                this.start = time;

                this.play();
            },
            calc(x) {
                let maxX = this.w - this.thumbW;
                if (x < 0) {
                    x = 0;
                }
                if (x >= maxX) {
                    x = maxX;
                }
                this.$refs.thumb.style.left = x + "px";
                this.$refs.progress.style.width = x + "px";
                let time = (x * this.duration) / (this.w - this.thumbW);
                return time;
            },

            formatterTime(t) {
                let h = parseInt(t / 3600);
                let m = parseInt((t - h * 3600) / 60);
                let s = parseInt(t - m * 60);
                s = s.toString().padStart(2, "0");
                if (h > 0) {
                    return `${h}:${m}:${s}`;
                } else {
                    return `${m}:${s}`;
                }
            },
        },
    };
</script>

<style lang="scss" scoped src="./my-audio.scss"></style>
